module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/view/other-employess/employees-grid/employees-grid.component.css
// module id = ./src/app/pages/view/other-employess/employees-grid/employees-grid.component.css
// module chunks = main